import React, { FC } from 'react'
import AddNewIsoContainer from 'containers/ISO/AddNewISo'

const AddNewIsoPage: FC = () => <AddNewIsoContainer />

export default AddNewIsoPage
